import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  snackBarAlert: null,
  beatLoader: 0
};

export const AlertsSlice = createSlice({
  name: 'AlertsSlice',
  initialState,
  reducers: {
    setSnackBarAlert: (state, action) => {
      state.snackBarAlert = action.payload;
    },
    setShowBeatLoader: (state) => {
      state.beatLoader += 1;
    },
    setHideBeatLoader: (state) => {
      state.beatLoader -= 1;
    }
  }
});

export const { setSnackBarAlert, setShowBeatLoader, setHideBeatLoader } = AlertsSlice.actions;

export default AlertsSlice.reducer;
